module.exports = __webpack_public_path__ + "img/header-engagementRingsCordial@2x.98202e5.webp";